export enum Language {
  TH = 'th',
  EN = 'en'
}
